/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as core from '../../core';
import * as errors from '../../errors/index';
import * as Truvity from '../index';

export class PreconditionFailedError extends errors.TruvityError {
    constructor(body: Truvity.PreconditionFailedProblems, rawResponse?: core.RawResponse) {
        super({
            message: 'PreconditionFailedError',
            statusCode: 412,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, PreconditionFailedError.prototype);
    }
}
